import { PHOTOS_STATUS, position_name } from './config';
import translationsUI from '~/view/ui/translationUI';
const rejectdTrans = require('~/utils/mockupData/rejectedMess.json');

export const getUniqueListBy = (arr, key) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};

export const reducePhotoCodeByPosition = (arrX, arrY, type, intl, locale) => {
  const missingLabel = `${intl.formatMessage(
    translationsUI.PAVE_UPLOAD_MESS_FAIL
  )}`;

  console.log({ arrX, arrY, type, intl, locale });
  let arrTemp = [];
  const { language_code } = locale;

  switch (type) {
    case PHOTOS_STATUS.MISSING:
      arrTemp = arrY.filter((itemY) => {
        const found = arrX
          .map((v) => {
            if (v === '70') {
              return 7;
            } else if (v === '40') {
              return 4;
            } else return v;
          })
          .find((itemX) => parseInt(itemX) === parseInt(itemY.photoCodeUpload));
        if (
          !!found &&
          itemY.status !== PHOTOS_STATUS.REJECTED &&
          itemY.status !== PHOTOS_STATUS.UPLOADING
        ) {
          itemY.message = `${missingLabel}`;
          itemY.percent = 0;
          itemY.photoCode = itemY.state;
          return true;
        }
        return false;
      });
      console.log('DEBUG: Checking missing photos', arrTemp);
      break;
    case PHOTOS_STATUS.REJECTED:
      arrTemp = arrY.filter((itemY) => {
        const found = arrX.find(
          (itemX) =>
            parseInt(itemX.photoCode) === parseInt(itemY.photoCodeUpload)
        );
        if (found && itemY.status !== PHOTOS_STATUS.UPLOADING) {
          const label_temp = handlefindJsonKey(rejectdTrans, language_code);
          itemY.message = label_temp
            ? label_temp[Object.keys(found.message)[0]]
              ? label_temp[Object.keys(found.message)[0]]
              : Object.values(found.message)[0]
            : rejectdTrans['en_us'][Object.keys(found.message)[0]]
            ? rejectdTrans['en_us'][Object.keys(found.message)[0]]
            : Object.values(found.message)[0];
          itemY.photoCode = itemY.state;
          itemY.rjCounting = found.rejectedCount;
          return true;
        }
        return false;
      });
      console.log('DEBUG: Checking rejected photos', arrTemp);
      break;
    default:
      break;
  }

  arrTemp = arrTemp.map((item) => {
    const { photoCodeUpload } = item;
    if (
      (photoCodeUpload === 7 && arrX.includes('70') && !arrX.includes('7')) ||
      (photoCodeUpload === 4 && arrX.includes('40') && !arrX.includes('4'))
    ) {
      item.optionalDynamicCode = photoCodeUpload === 7 ? '70' : '40';
      item['optionalDynamicPosition'] =
        photoCodeUpload === 7
          ? 'FRONT PASSENGER SIDE CLOSE-UP'
          : 'FRONT DRIVER SIDE CLOSE-UP';
    }
    return item;
  });

  console.log('DEBUG: arrTemp', arrTemp);
  return arrTemp;
};

export const handlefindJsonKey = (json, code) => {
  return Object.keys(json).reduce(
    (arr, item) => (item.includes(code) ? json[item] : arr),
    {}
  );
};

export const mapPhotoCodeToPosition = (code) => {
  switch (parseInt(code)) {
    case 1:
      return position_name['VIN'];
    case 2:
      return position_name['INTERIOR'];
    case 3:
      return position_name['ODOMETER'];
    case 4:
      return position_name['LEFT_VIEW'];
    case 5:
      return position_name['FRONT_LEFT'];
    case 6:
      return position_name['FRONT_VIEW'];
    case 7:
      return position_name['FRONT_RIGHT'];
    case 8:
      return position_name['RIGHT_VIEW'];
    case 9:
      return position_name['REAR_RIGHT'];
    case 10:
      return position_name['REAR_VIEW'];
    case 11:
      return position_name['REAR_LEFT'];
    case 12:
      return position_name['WINDSHIELD'];
    case 13:
      return position_name['TIRE'];
    case 14:
      return position_name['REAR_TIRE'];
    default:
      break;
  }
};

export const handleRenderDamages = (object) => {
  try {
    let render = [];
    if (!!object && object.length > 0) {
      for (var key in object) {
        const damage = object[key];
        const damagePhoto = object[key].photo || {};
        if (damagePhoto.url !== false) {
          const photo = {
            code: damagePhoto.code || '00',
            url: damagePhoto.url + '?v=' + Date.now(),
          };
          if (damage) {
            render.push({
              photo,
              damage,
              key,
            });
          }
        }
      }
      return render;
    }
  } catch (error) {
    console.log('error', error);
  }
};
